export default __webpack_public_path__ + "static/media/avatar_grumpy_cat4.5d444962.mp3";